import '../stylesheets/application';
import $ from 'jquery';
import toastr from 'toastr';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '@hotwired/turbo-rails';
import '../controllers';

// @rails/ujs 7.1+ ships an ESM build (default export only), so
// require('@rails/ujs').start is undefined — use the default import.
require('@rails/ujs').default.start();
require('@rails/activestorage').start();
require('./custom/bootstrap_custom.js');
require('select2');

global.$ = jQuery;
global.toastr = toastr;

$(() => {
  AOS.init();
});

$(window).on('load', () => {
  AOS.refresh();
});
